import React from 'react'

import {StyledTextArea, TextAreaWrapper} from './TextArea.styled'

import {theme} from '~/styles/theme'

type TextAreaProps = {
  className?: string
  height?: string | null
  fontSize?: keyof typeof theme.fontSize
  required?: boolean
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>

export const TextArea: React.FC<TextAreaProps> = ({
  className,
  fontSize = 'lg',
  height = '300px',
  required,
  ...props
}) => (
  <TextAreaWrapper
    height={height || undefined}
    className={className}
    required={required}>
    <StyledTextArea fontSize={fontSize} {...props} />
  </TextAreaWrapper>
)
